export const GET_ALL_OBSERVERS = "observer/all";
export const CREATE_OBSERVER = "observer/create";
export const WATCHER_LINK = "observer/WATCHER_LINK";
export const WATCHER_LINK_SUBACCOUNTS = "observer/WATCHER_LINK_SUBACCOUNTS";
